import clsx from "clsx";
import { InlinePopupProps } from "csi/middleware/inline/InlinePopup";
import InlineSingleSelect from "csi/middleware/inline/InlineSingleSelect";
import xml from "csi/xml";
import { FlexRow, OverflowText } from "designSystem/index";
import { ComponentItem } from "designSystem/types/component-item-types";
import React, { FunctionComponent, HTMLAttributes, ReactNode } from "react";

const ICON_MAP = {
	1: "critical",
	2: "high",
	3: "medium",
	4: "low",
	5: "minor",
};

function getPriorityIcon(key: string) {
	return ICON_MAP[key];
};

const PriorityIconInlineSelect: FunctionComponent<InlinePopupProps> = (props) => {
	function renderOption<T extends ComponentItem>(props: HTMLAttributes<HTMLLIElement>, option: T, { selected }): ReactNode {
		const { id, value } = option;
		const priorityText = xml.enumGetText(value);
		const icon = getPriorityIcon(priorityText);

		const iconSpanCss = clsx("csi-icon-block", "csi-icon-with-label-icon", "csi-custom-icon", "csi-custom-icon-" + icon);

		return (
			<li 
				{...props} 
				data-csi-value={option.value}
				key={id}
			>
				<FlexRow>
					<span className={iconSpanCss} />
					<OverflowText
						lineHeight={16}
						marginLeft={1}
						res={value}
					/>
				</FlexRow>
			</li>
		);
	}

	return (
		<InlineSingleSelect
			customRenderOption={renderOption}
			{...props}
		/>
	);
};

export default PriorityIconInlineSelect;
